import { render, staticRenderFns } from "./ExaminationSchedulerBatch.vue?vue&type=template&id=028d8897&"
import script from "./ExaminationSchedulerBatch.vue?vue&type=script&lang=js&"
export * from "./ExaminationSchedulerBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports